
ADILF.define('streamhub-sdk/ui/auth-required-command',['require','exports','module','streamhub-ui/auth-required-command'],function (require, exports, module) {module.exports = require('streamhub-ui/auth-required-command');

});
